import { Component, OnInit, SimpleChanges } from '@angular/core';
import { ClinicDetailQuery } from '../../../../shared/state/clinic-detail/clinic-detail.query';
import { ClinicDetailState } from '../../../../shared/state/clinic-detail/clinic-detail.store';
import { Router } from '@angular/router';
import { SettingsQuery } from '../../../../shared/state/settings/settings.query';
import { Observable, combineLatest } from 'rxjs';
import { UserState } from '../../../../shared/state/user/user.store';
import { UserQuery } from '../../../../shared/state/user/user.query';
import { SettingsService } from 'src/app/shared/state/settings/settings.service';
import { HeaderPictureQuery } from '../../../../shared/state/header-picture/header-picture.query';
import { HeaderBackgroundQuery } from '../../../../shared/state/header-background/header-background.query';
import { HeaderIconQuery } from '../../../../shared/state/header-icon/header-icon.query';
import { KeyboardQuery } from '../../../../shared/state/keyboard/keyboard.query';
import { AppointmentWizardComponent } from '../../../appointment-wizard/pages/appointment-wizard/appointment-wizard.component';
import { LoadingService } from '../../../../shared/state/loading/loading.service';
import { UserService } from '../../../../shared/state/user/user.service';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { ClinicQuery } from '../../../../shared/state/clinic/clinic.query';
import { ClinicDetailService } from 'src/app/shared/state/clinic-detail/clinic-detail.service';
import { ClinicService } from 'src/app/shared/state/clinic/clinic.service';
import { map, tap } from 'rxjs/operators';
import { SocialNetworksComponent } from '../../components/social-networks/social-networks.component';
import { Capacitor } from '@capacitor/core';
import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';
import { CompanyQuery } from 'src/app/shared/state/company/company.query';
import { AppLauncher } from '@capacitor/app-launcher';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-clinic-view',
    templateUrl: './clinic-view.component.html',
    styleUrls: ['./clinic-view.component.scss'],
})
export class ClinicViewComponent implements OnInit {
    clinic$: Observable<ClinicDetailState>;
    clinic: ClinicDetailState;
    user$: Observable<UserState>;
    headerPicture$;
    headerBackground$;
    headerIcon$;
    keyboardIsShowing: Observable<boolean>;
    isGeneric$: Observable<boolean>;
    isBrowser$: Observable<boolean>;
    isCurrentClinicFav = false;

    //Flowwwer template
    showBackButtonHeader$: Observable<boolean>;

    public mapsSrc: SafeUrl = '';

    constructor(
        private userService: UserService,
        private modalController: ModalController,
        private loadingService: LoadingService,
        private clinicDetailQuery: ClinicDetailQuery,
        private settingsQuery: SettingsQuery,
        private router: Router,
        private userQuery: UserQuery,
        private settingsService: SettingsService,
        private headerPictureQuery: HeaderPictureQuery,
        private headerBackgroundQuery: HeaderBackgroundQuery,
        private headerIconQuery: HeaderIconQuery,
        private keyboardQuery: KeyboardQuery,
        private clinicQuery: ClinicQuery,
        private navCtrl: NavController,
        private clinicDetailService: ClinicDetailService,
        private callNumber: CallNumber,
        private companyQuery: CompanyQuery,
        private platform: Platform,
        private sanitizer: DomSanitizer
    ) {
        // @ts-ignore
        window.initMap = () => {
            const position = { lat: this.latitude, lng: this.longitude };
            // @ts-ignore
            const map = new google.maps.Map(document.getElementById('map'), {
                center: position,
                disableDefaultUI: true,
                zoom: 18,
                draggable: false
            });

            // @ts-ignore
            const marker = new google.maps.Marker({
                position,
                map,
            });
        };
    }

    async ngOnInit(): Promise<void> {
        this.headerPicture$ = this.headerPictureQuery.select('company');
        this.headerBackground$ = this.headerBackgroundQuery.select('company');
        this.headerIcon$ = this.headerIconQuery.select('company');
        this.clinic$ = this.clinicDetailQuery.select();
        this.clinic$.subscribe((clinic) => {
            this.clinic = clinic;
            if (clinic.id !== '') {
                this.initScriptMap();
            }
        });
        this.user$ = this.userQuery.select();
        this.keyboardIsShowing = this.keyboardQuery.select('isShowing');
        this.isGeneric$ = this.settingsQuery.selectIsGeneric();
        this.isBrowser$ = this.settingsQuery.select('browser');
        this.clinicDetailQuery
            .selectIsCurrentClinicFav()
            .subscribe((isFavouriteActive) => {
                this.isCurrentClinicFav = isFavouriteActive;
            });

        //Flowwwer template
        this.showBackButtonHeader$ = this.settingsQuery.selectShowBackButtonHeader();
    }

    /** Comprueba si el usuario puede pedir citas antes de abrir el modal de cita */
    async checkUserCanMakesAppointment() {
        await this.userService.checkUserCanMakesAppointment();
    }

    async presentModalAppointmentWizard() {
        //TODO: Mejoramos parpadeo, comentando las lineas siguientes, ya que justo seguido hay otra llamada, entonces para hacer la
        //llamada del check, no mostramos spinner.
        //this.loadingService.updateShowSpinner(true);
        await this.checkUserCanMakesAppointment();
        //this.loadingService.updateShowSpinner(false);
        const modal = await this.modalController.create({
            component: AppointmentWizardComponent,
            cssClass: this.settingsQuery.browser
                ? 'modal-flowwwer modal-browser-appointment'
                : 'modal-flowwwer',
        });
        return await modal.present();
    }

    async presentModalSocialNetworks() {
        const modal = await this.modalController.create({
            component: SocialNetworksComponent,
            breakpoints: [0, 0.4, 0.6],
            initialBreakpoint: 0.45,
        });
        return await modal.present();
    }

    goHome(event) {
        event?.stopPropagation();
        /** Solo puedo volver atrás si no estoy en personalzas o si soy personalizada y tengo más de 1 centro */
        if (
            !this.settingsQuery.isPersonalized() ||
            this.clinicQuery.getValue().clinicsFound.length > 1
        ) {
            this.navCtrl.navigateBack(
                '/' +
                    (this.settingsQuery.isPersonalized()
                        ? this.settingsQuery.currentSystemKey
                        : '')
            );
        }
    }

    signUp() {
        this.router.navigate([
            '/' +
                this.settingsQuery.systemKeyURL +
                '/' +
                this.clinicDetailQuery.id +
                //'/register/social', E.C.S: Se desactiva esta funcionalidad momentaneamente
                '/register/default',
        ]);
    }

    clickFavouriteCurrentClinic() {
        this.clinicDetailService.togleFavCurrentClinic();
    }

    callClinic() {
        if (Capacitor.isNativePlatform()) {
            this.callNumber
                .callNumber(this.clinicDetailQuery.phone, true)
                .then((res) => console.log('Launched dialer!', res))
                .catch((err) => console.log('Error launching dialer', err));
        } else {
            const win = window.open('tel:' + this.clinicDetailQuery.phone);
            win.focus();
        }
    }

    /** Flowwwer template */
    get hasSocialNetwork() {
        return (
            this.clinicDetailQuery.email !== '' ||
            this.clinicDetailQuery.twitter !== '' ||
            this.clinicDetailQuery.facebook !== '' ||
            this.clinicDetailQuery.website !== '' ||
            this.clinicDetailQuery.instagram !== '' ||
            this.clinicDetailQuery.googleReviews !== ''
        );
    }

    //TODO: Código duplicado, y preparar para que se pueda guardar la API por company
    get longitude(): number {
        return parseFloat(this.clinic.longitude);
    }

    get latitude(): number {
        return parseFloat(this.clinic.latitude);
    }

    get hasMap(): boolean {
        return (
            this.clinic.id !== '' &&
            this.clinic.latitude !== '0' &&
            this.clinic.longitude !== '0' &&
            environment.googleMapsApiKey !== ''
        );
    }

    initScriptMap(): void {
        this.mapsSrc = this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.google.com/maps/embed/v1/place?key=${environment.googleMapsApiKey}&q=${this.clinic.latitude},${this.clinic.longitude}&zoom=18`);
    }

    async openAppMaps() {
        const { latitude, longitude, comercialName } = this.clinicDetailQuery;

        if (Capacitor.isNativePlatform()) {
            const url = this.platform.is('android')
                ? `geo:0,0?q=${latitude},${longitude}`
                : `http://maps.apple.com/?ll=${latitude},${longitude}&q=${encodeURIComponent(
                      comercialName
                  )}`;

            await AppLauncher.openUrl({ url });
        } else {
            const urlMaps = `https://maps.google.com/?q=${latitude},${longitude}`;
            window.open(urlMaps);
        }
    }

    imgLoad(image) {
        const parentContainer = image.parentNode;
        const originalWidth = image.naturalWidth;
        const originalHeight = image.naturalHeight;
        const aspectRatio = originalWidth / originalHeight;
      
        const scaledWidth = 20 * aspectRatio; // Ancho escalado en función del aspect ratio y la altura fija de 20 rem
      
        image.style.minWidth = scaledWidth + 'rem';
        parentContainer.scrollLeft = 0;

        if (image.width > window.innerWidth) {            
            parentContainer.classList.add('banner-snap');
        }
    }
}
